<template>
  <div class="div-conteudo">
    <transition name="modal" v-if="carregando">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
            <label>Aguarde. Carregando.</label>
          </div>
        </div>
      </div>
    </transition>
    <div class="fora" v-else>
      <div class="index centro">
        <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
        <div class="topo-index">
          <h1>Cargos</h1>
          <!-- Trava adicionada no botão Novo -->
          <router-link :to="{ name: 'CargoColegiadoNew' }" v-if="permissoes.pode_criar">
            <span>+</span> Novo Cargo
          </router-link>
        </div>
        <!-- Removida a trava de administrador da pesquisa -->
        <div class="caixa-pesquisa">
          <h2 @click="togglePesquisa()">
            Pesquisa
            <span>
              <template v-if="!exibirPesquisa">&#9650;</template>
              <template v-else>&#9660;</template>
            </span>
          </h2>
          <transition name="slide">
            <form @submit.prevent="fazerBusca" v-if="!exibirPesquisa">
              <div>
                <div class="row3-data">
                  <div class="item">
                    <label>Nome:</label>
                    <input type="text" placeholder="Digite o nome" v-model="filtro.nome" />
                  </div>
                </div>
              </div>
              <div class="botoes-pesquisa">
                <div class="bt-pesquisa">
                  <button title="Pesquisar" type="submit">
                    <img src="../../assets/imagens/pesquisa.png" class="pesquisa" alt=" " />
                    Pesquisar
                  </button>
                </div>
                <div class="bt-limpar">
                  <button title="Limpar" @click="limparFiltro()">
                    <img src="../../assets/imagens/icon-eraser.png" class="limpar" alt=" " />
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </form>
          </transition>
        </div>
        <div class="n-div">
          <div class="nresultados" v-show="!carregando">
            <label>Total de Resultados: {{ this.totalResultadosTexto }}</label>
          </div>
          <div class="npagina" v-show="!carregando">
            <label>Resultados por Página </label>
            <select :value="qtd_por_pagina" @input="mudouQtdPagina">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
        <div class="container-tabela">
          <!-- Prop permissoes enviada para a tabela -->
          <TabelaResultadosCargoColegiado 
            :cargosColegiados="cargosColegiados" 
            :permissoes="permissoes"
            v-if="!carregando && !erroFiltro">
          </TabelaResultadosCargoColegiado>
        </div>
        <paginate v-if="!carregandoFiltro && !carregando" v-model="pagina" :page-count="pageCount"
          :click-handler="mudouPagina" :prev-text="'Anterior'" :next-text="'Próxima'" :container-class="'className'"
          active-class="active-page"></paginate>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";
import tryParseInt from "../../helpers/tryParseInt";
import metaDados from "../../helpers/metaDados";

import TabelaResultadosCargoColegiado from "../../components/cargo_colegiado/TabelaResultadosCargoColegiado.vue";
import CargoColegiadoApi from "../../services/CargoColegiadoApi";
import MsgErroFormularios from "../../components/MsgErroFormularios.vue";

export default {
  name: "CargoColegiado",
  metaInfo() {
    return {
      title: "Cargos Colegiados",
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [
        {
          vmid: "description",
          name: "description",
          property: "description",
          content: "Página de acesso e pesquisa de todos os tipos de cargos.",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: "Página de acesso e pesquisa de todos os tipos de cargos.",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "Tipos de cargos - Casa Civil do Estado de Goiás",
        },
        ...metaDados(this.$route),
      ],
    };
  },
  data() {
    return {
      cargosColegiados: [],
      carregando: true,
      msgErros: {
        cargoColegiado: '',
      },
      erro: false,
      totalResultados: null,
      totalResultadosTexto: null,
      pagina: 1,
      qtd_por_pagina: 10,
      filtro: {
        nome: null,
      },
      permissoes: {
        pode_visualizar: true,
        pode_criar: true,
        pode_editar: true,
        pode_deletar: true
      },
      exibirPesquisa: true,
      carregandoFiltro: false,
      erroFiltro: false,
    };
  },
  components: {
    MsgErroFormularios,
    TabelaResultadosCargoColegiado, 
    Paginate,
  },
  created() {
    this.carregarQtdPorPagina();
    this.carregarValoresFiltro();
    this.carregarCargosColegiados();
  },
  watch: {
    $route: function (to, from) {
      const mudouQuery =
        to.query.pagina != from.query.pagina ||
        to.query.qtd_por_pagina != from.query.qtd_por_pagina ||
        to.query.nome != from.query.nome;

      if (
        from.name == "CargoColegiado" &&
        to.name == "CargoColegiado" &&
        mudouQuery
      ) {
        this.carregarValoresFiltro();
        this.carregarCargosColegiados();
      }
    },
  },
  methods: {
    fecharErro() {
      this.erro = false;
    },
    togglePesquisa: function () {
      this.exibirPesquisa = !this.exibirPesquisa;
    },
    async fazerBusca() {
      this.$router.push({
        name: this.$route.name,
        query: {
          ...this.filtro,
          pagina: 1,
          qtd_por_pagina: this.qtd_por_pagina,
        },
      });
    },
    mudouQtdPagina: function (event) {
      const novaQtdPagina = parseInt(event.target.value);
      if (novaQtdPagina < this.qtd_por_pagina) {
        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(this.pagina);
      } else {
        let novaPagina = Math.ceil(
          (this.qtd_por_pagina * this.pagina) / novaQtdPagina
        );

        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(novaPagina);
      }
    },
    getParam: function (name) {
      if (this.$route && this.$route.query) {
        return this.$route.query[name];
      }
      return null;
    },
    mudouPagina: function (page) {
      this.pagina = page;

      const filtro = {
        nome: this.getParam("nome"),
      };

      this.$router.push({
        name: this.$route.name,
        query: {
          ...filtro,
          pagina: this.pagina,
          qtd_por_pagina: this.qtd_por_pagina,
        },
      });
    },
    async carregarValoresFiltro() {
      try {
        if (this.carregandoFiltro && !this.erroFiltro) return;

        this.erroFiltro = false;
      } catch (err) {
        console.log("carregarValoresFiltro", err);
        this.carregandoFiltro = false;
        this.erroFiltro = true;
      }
    },
    async carregarCargosColegiados() {
      try {
        this.carregando = true;
        this.erro = false;

        this.qtd_por_pagina = this.getParam("qtd_por_pagina") || this.qtd_por_pagina;

        this.armazenarQtdPorPagina();

        const pagina = this.getParam("pagina") || 1;
        this.pagina = parseInt(pagina);

        this.filtro = {
          nome: this.getParam("nome"),
        };

        const cargoColegiadoApi = new CargoColegiadoApi();

        if (cargoColegiadoApi.cancelTokens.getCargosColegiados) {
          cargoColegiadoApi.cancelTokens.getCargosColegiados.cancel();
        }

        const data = await cargoColegiadoApi.getCargosColegiados({
          page: this.pagina,
          qtd_por_pagina: this.qtd_por_pagina,
          nome: this.filtro.nome,
        });

        // Captura as permissões vindas do backend
        this.cargosColegiados = data.resultados || data.cargos_colegiados || data;
        this.permissoes = data.permissoes || this.permissoes; 
        this.totalResultados = data.total_resultados;
        
        if (data.total_resultados >= 1000) {
          this.totalResultadosTexto = (data.total_resultados / 1000).toFixed(3).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        } else {
          this.totalResultadosTexto = data.total_resultados;
        }
        this.carregando = false;
      } catch (err) {
        console.log("carregarCargosColegiados falhou", err);
        this.carregando = false;
        this.erro = true;
      }
    },

    limparFiltro: function () {
      this.togglePesquisa();
      this.filtro = {
        nome: undefined,
      };
    },
    armazenarQtdPorPagina() {
      localStorage.setItem(
        "qtd_por_pagina_tipo",
        this.qtd_por_pagina
      );
    },
    carregarQtdPorPagina() {
      const qtd = localStorage.getItem("qtd_por_pagina_tipo");
      if (qtd) {
        this.qtd_por_pagina = tryParseInt(qtd);
      }
    },
  },
  computed: {
    pageCount: function () {
      if (
        this.totalResultados !== undefined &&
        this.totalResultados !== null &&
        this.qtd_por_pagina !== null &&
        this.qtd_por_pagina !== undefined &&
        this.totalResultados > 0 &&
        this.qtd_por_pagina > 0
      ) {
        return Math.ceil(this.totalResultados / this.qtd_por_pagina);
      }
      return 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: "1066px") {
  .div-conteudo {
    width: 100vw;

    .centro {
      max-width: 96vw;
      margin: 0 auto;
    }

    .index {
      .topo-index {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;

        h1 {
          font-family: "Montserrat-Medium";
          font-weight: bold; 
          color: #ffa600;
          font-size: 1.8rem;
        }

        a {
          color: #005516;
          text-decoration: none;
          font-family: "Montserrat-Medium";
          border: #005516 solid 0.15rem;
          padding: 0.3rem 2rem;
          border-radius: 0.2rem;
          transition: 0.2s;
          margin-bottom: 1.5rem;
          margin-top: 1.5rem;

          span {
            font-family: "Montserrat-Bolder";
          }
        }

        a:hover {
          color: white;
          background-color: #005516;
        }
      }

      .caixa-pesquisa {
        background-color: #ededed;
        padding: 1rem;
        border-radius: 1rem 1rem 0 0;

        .row3-data {
          display: grid;
          grid-template-columns: 1fr;
          gap: 1.5rem;

          .item {
            width: -webkit-fill-available;
          }
        }

        input {
          border-radius: 0.5rem;
          border: solid 0.1rem;
        }

        h2 {
          margin: 0;
          text-transform: uppercase;
          color: #005516;
          font-size: 1.2rem;
          font-family: "Montserrat-Medium";
          font-weight: bold; 
          cursor: pointer;
        }

        .item {
          display: grid;
          margin: .5rem 0 .5rem 0;

          label {
            width: fit-content;
            margin-bottom: 0.3rem;
            color: black;
            font-family: "Karla", sans-serif;
            font-size: 0.95rem;
            font-weight: 500;
          }

          input {
            height: 2rem;
            font-family: "Montserrat-Medium";
            padding-left: 0.5rem;
            font-size: 0.9rem;
          }
        }

        .botoes-pesquisa {
          display: flex;
          justify-content: space-between;
          margin-top: 1rem;

          .bt-pesquisa button {
            height: 2.5rem;
            background-color: #005516;
            color: white;
            border: #005516 solid 0.15rem;
            font-size: 1rem;
            padding: 0.3rem 2rem;
            border-radius: 2rem;

            img {
              height: 1rem;
              margin-right: 0.5rem;
            }
          }

          .bt-limpar button {
            height: 2.5rem;
            background-color: #FFFFFF;
            color: #000;
            border: white solid 0.15rem;
            font-size: 1rem;
            padding: 0.3rem 2rem;
            border-radius: 2rem;

            img {
              height: 1.5rem;
              margin-right: 0.5rem;
            }
          }
        }
      }

      .n-div {
        display: flex;
        justify-content: space-between;

        .nresultados label {
          color: #005516;
          font-size: 0.9rem;
          font-family: "Montserrat-Bold";
          margin-top: 0.5rem;
        }

        .npagina label {
          color: #005516;
          font-size: 0.9rem;
          font-family: "Montserrat-Medium";
          margin: 0.5rem .5rem 0 0;
        }

        .npagina select {
          border: none;
          background-color: #edf2ee;
          font-size: 0.9rem;
          margin-top: 0.5rem;
          cursor: pointer;
        }
      }

      .container-tabela {
        margin-top: .5rem;
        border-radius: 1.5rem;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

        .resultados {
          width: 100%;
          height: max-content;
          margin: 0;
        }
      }
    }
  }
}

@media screen and (min-width: "60px") and (max-width: "1065px") {
  .div-conteudo {
    width: 100vw;

    .centro {
      width: 90vw;
      margin: 0 auto;
    }

    .index {
      .topo-index {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;

        h1 {
          font-family: "Montserrat-Medium";
          font-weight: bold; 
          color: #ffa600;
          font-size: 1.8rem;
        }

        a {
          color: #005516;
          text-decoration: none;
          font-family: "Montserrat-Medium";
          font-weight: bold;
          border: #005516 solid 0.15rem;
          padding: 0.3rem 2rem;
          border-radius: 0.2rem;
          transition: 0.2s;
          margin-bottom: 1.5rem;
          margin-top: 1.5rem;
        }
      }

      .caixa-pesquisa {
        background-color: #dbdbdb;
        padding: 1rem;
        border-radius: 1rem 1rem 0 0;

        h2 {
          margin: 0;
          text-transform: uppercase;
          color: #005516;
          font-size: 1.2rem;
          font-family: "Montserrat-Medium";
          font-weight: bold; 
          cursor: pointer;
        }

        .item {
          display: grid;
          margin: .5rem 0 .5rem 0;

          label {
            width: fit-content;
            margin-bottom: 0.3rem;
            color: black;
            font-family: "Karla", sans-serif;
            font-size: 0.95rem;
            font-weight: 500;
          }

          input {
            height: 2rem;
            font-family: "Montserrat-Medium";
            padding-left: 0.5rem;
            font-size: 0.9rem;
          }
        }
      }
    }
  }
}

.modal-mask {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: fit-content;
  height: 0px auto;
  margin: 0px auto;
  position: relative;
  overflow-y: auto;
  overflow-x: auto;
  font-size: 1.5rem;
  font-family: "Montserrat-Medium";

  img {
    width: 2rem;
    height: 2rem;
    margin-right: 1.6rem;
  }

  label {
    font-size: 1.3rem;
    color: rgba(255, 255, 255, 0.556);
    display: inline;
    position: relative;
    top: 0rem;
  }
} 
</style>